export const hhmmToMinutes = (hhmm) => {
    const [h, m] = hhmm.split(':').map(Number);
    return h * 60 + m;
};

export const minutesToHHMM = (minutes) => {
    const h = Math.floor(minutes / 60).toString().padStart(2, '0');
    const m = (minutes % 60).toString().padStart(2, '0');
    return `${h}:${m}`;
};

export const timeStringToDate = (hhmm) => {
    const [h, m] = hhmm.split(':').map(Number);
    const date = new Date();
    date.setHours(h, m, 0, 0);
    return date;
};

export  const dateToTimeFormat24 = (date) => {
    const h = date.getHours().toString().padStart(2, '0');
    const m = date.getMinutes().toString().padStart(2, '0');
    return `${h}:${m}`;
};